module.exports = __webpack_public_path__ + "static/img/Signature_logo_with_text.6e5aff0.png";